import gql from "graphql-tag";

export const MY_CAFETERIA_GET_CURRENT_STATEMENT_ITEMS = gql`
  query getCurrentCafeteriaStatementItems($contractCode: String!) {
    getCurrentCafeteriaStatementItems(contractCode: $contractCode) {
      _id
      origin
      contractCode
      menuItem {
        code
        name
        planable
        isPeriodical
        isSZEPCardItem
        isSZEPActiveHungariansCardItem
      }
      startDate
      endDate
      itemSerial
      type
      amount
      cost
      plan
      szepCardApplicationAmount
    }
  }
`;

export default MY_CAFETERIA_GET_CURRENT_STATEMENT_ITEMS;
